import React from "react";
import Lottie from "lottie-react";

import Dialog from "components/common/Dialog";
import addPaymentLoader from "assets/loaders/addPaymentLoader.json";

import "./AddPaymentLoaderModal.scss";

function AddPaymentLoaderModal({ open = false, title = "", description = "", size = "sm" }) {
  return (
    <Dialog
      open={open}
      content={
        <div className="onboarding-payment-loader-modal">
          <div className="lottie-animation-container">
            <Lottie animationData={addPaymentLoader} loop autoplay className="payment-lottie-animation" />
          </div>
          <div className="onboarding-payment-loader-content">
            <p className="heading-h2-semibold text-center color-text-headings-primary">{title}</p>
            <p className="onboaring-payment-loader-text">{description}</p>
          </div>
        </div>
      }
      size={size}
    />
  );
}

export default AddPaymentLoaderModal;
